import {useCallback, useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';

import {hideLoader, showLoader} from '@/state/slices/loadersSlice';

const UWM_UNAVAILABILITY_TIMEOUT_MS = 30_000;

export const useUWMUnavailabilityHandler = () => {
    const dispatch = useDispatch();
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [hasDataError, setHasDataError] = useState(false);
    const [refreshTrigger, setRefreshTrigger] = useState(false);
    const timeoutRef = useRef(null);

    const shouldShowLoader = !isDataLoaded && !hasDataError && !isPopupVisible;

    const closePopup = useCallback(() => {
        clearTimeout(timeoutRef.current);
        setIsPopupVisible(false);
    }, []);

    const handleRefresh = useCallback(() => {
        closePopup();
        setIsDataLoaded(false);
        setHasDataError(false);
        setRefreshTrigger((prev) => !prev);
    }, [closePopup]);

    useEffect(() => {
        dispatch(shouldShowLoader ? showLoader() : hideLoader());
    }, [dispatch, shouldShowLoader]);

    useEffect(() => {
        if (isDataLoaded) {
            closePopup();
            return;
        }

        clearTimeout(timeoutRef.current);

        if (hasDataError) {
            setIsPopupVisible(true);
            return;
        }

        timeoutRef.current = setTimeout(() => {
            setIsPopupVisible(true);
        }, UWM_UNAVAILABILITY_TIMEOUT_MS);
    }, [isDataLoaded, hasDataError, refreshTrigger, closePopup]);

    return {
        isPopupVisible,
        handleRefresh,
        setIsDataLoaded,
        setHasDataError,
    };
};
